import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsDeleteUsers_id = z.any()
export type TagsDeleteUsers_id = z.infer<typeof tagsDeleteUsers_id>

export const descriptionDeleteUsers_id = z.any()
export type DescriptionDeleteUsers_id = z.infer<typeof descriptionDeleteUsers_id>

export const paramsDeleteUsers_id = z.object({ "id": z.string().uuid() })
export type ParamsDeleteUsers_id = z.infer<typeof paramsDeleteUsers_id>

export const responseDeleteUsers_id = z.any()
export type ResponseDeleteUsers_id = z.infer<typeof responseDeleteUsers_id>

interface IDeleteUsers_id extends BaseMethodType {
  tags: TagsDeleteUsers_id,
  description: DescriptionDeleteUsers_id,
  params: ParamsDeleteUsers_id,
  response: ResponseDeleteUsers_id
}
export const URL = '/users/:id'
export const validation = {
  delete: {
    tags: tagsDeleteUsers_id,
    description: descriptionDeleteUsers_id,
    params: paramsDeleteUsers_id,
    response: responseDeleteUsers_id
  }
}
export interface Users_id extends BaseRouteType {
  delete: IDeleteUsers_id
}